import router from "@/router";
import {http} from "@/config/http";
import _ from "lodash";

const namespaced = true;

const getDefaultState = () => {
    return {
        userData: {
            title: "",
            first_name: "",
            last_name: "",
            email: "",
            company: "",
            contact_no: "",
            user_id: "",
            role: [],
            user_name: "",
            parent_id: "",
            role: "",
            br_code:"",
            active: "",
            reject_reason: ""
        },
        role_list: [],
        branch_list: [],
        errors: [],
        all_user_list: {},
        system_user_list:{},
        filter_user_list:{}
    };
};

const state = getDefaultState();

const getters = {};

const mutations = {
    setAllUserList(state, data) {
        state.all_user_list = data.data;
    },
    setSystemUserList(state, data) {
        state.system_user_list = data.data;
    },
    setFilterUserList(state, data) {
        state.filter_user_list = data.data;
    },
    setUserData(state, data) {
        state.userData.title = data.user.title;
        state.userData.first_name = data.user.first_name;
        state.userData.last_name = data.user.last_name;
        state.userData.email = data.user.email;
        state.userData.contact_no = data.user.contact_no;
        state.userData.user_id = data.user.user_id;
        state.userData.role = data.user.roles[0].id;
        state.userData.user_name = data.user.user_name;
        state.userData.agent_code = data.user.agent_code;
        state.userData.br_code = data.user.br_code;
        state.userData.action_type = "Edit";
        state.userData.parent_id = data.user.parent_id;
        state.userData.user_status = data.user.active == true ? 1 : 0;
        state.userData.reject_reason = data.user.reject_reason;
    },

    resetUserData(state, data) {
        state.errors = [];
        state.userData = [];
    },

    setRoleList(state, data) {
        state.role_list = data;
    },

    setFormErrors(state, data) {
        state.errors = [];
        if (data) {
            state.errors = data.details;
        }
    },
    setParameterDataList(state, data){
        switch (data.type) {
            case "branch_list":
                state.branch_list = data.data;
                break
            default:
                break
        }
    },
};

const actions = {
    resetUserData({commit}, data) {
        commit("resetUserData");
    },
    async getBranchDataList({commit}, data) {
        await http
            .post("parameters/ins_cmp_list", data)
            .then((response) => {
                if (!response.error) {
                    commit("setParameterDataList", response.data);
                } else {

                }
            })
            .catch((error) => {
            });
    },
    async getRoleList({commit}, data) {
        await http
            .get("roles/allowed_role_list", null)
            .then(response => {
                commit("setRoleList", response.data.data);
            })
            .catch(error => {
                commit(
                    "showAlert",
                    {
                        title: "Error!",
                        msg: "Error occured while retriving data.",
                        type: "error",
                        position: "rightTop"
                    },
                    {root: true}
                );
            });
    },
    async createUser({commit}, data) {
        return new Promise((resolve, reject) => {
            http
                .post("users/create", data)
                .then(response => {
                    if (response.data.success) {
                        commit("setFormErrors", "");
                        resolve(response);
                    } else if (response.data.error) {
                        if (response.data.error.code == "Exception") {
                            resolve(response);
                        } else {
                            commit("setFormErrors", response.data.error);
                            resolve(response);
                        }
                    }
                })
                .catch(error => {
                    commit(
                        "showAlert",
                        {
                            title: "Error!",
                            msg: "Error occured while creating user.",
                            type: "error",
                            position: "centerTop"
                        },
                        {root: true}
                    );
                });
        });
    },

    async updateUserStatus({commit}, data) {
        return new Promise((resolve, reject) => {
            http
                .post("users/status/update", data)
                .then(response => {
                    if (response.data.success) {
                        commit("setFormErrors", "");
                        resolve(response);
                    } else if (response.data.error) {
                        if (response.data.error.code == "Exception") {
                            resolve(response);
                        } else {
                            commit("setFormErrors", response.data.error);
                            resolve(response);
                        }
                    }
                })
                .catch(error => {
                    commit(
                        "showAlert",
                        {
                            title: "Error!",
                            msg: "Error occured.",
                            type: "error",
                            position: "centerTop"
                        },
                        {root: true}
                    );
                });
        });
    },

    async updateUser({commit}, data) {
        return new Promise((resolve, reject) => {
            http
                .post("users/" + data.user_id, data)
                .then(response => {
                    if (response.data.success) {
                        commit("setFormErrors", "");
                        resolve(response);
                    } else if (response.data.error) {
                        if (response.data.error.code == "Exception") {
                            resolve(response);
                        } else {
                            commit("setFormErrors", response.data.error);
                            resolve(response);
                        }
                    }
                })
                .catch(error => {
                    commit(
                        "showAlert",
                        {
                            title: "Error!",
                            msg: "Error occured.",
                            type: "error",
                            position: "centerTop"
                        },
                        {root: true}
                    );
                });
        });
    },

    async getUserData({commit}, userId = null) {
        await http
            .get("users/" + userId + "", {}, {})
            .then(response => {
                if (response) {
                    commit("setUserData", response.data);
                } else {
                    commit("setUserData", null);
                }
            })
            .catch(error => {
                commit(
                    "showAlert",
                    {
                        title: "Error!",
                        msg: "Error occured.",
                        type: "error",
                        position: "centerTop"
                    },
                    {root: true}
                );
            });
    },

    async getAllUserData({commit}, data) {
        await http
            .get("users/get_all_users", null)
            .then(response => {
                commit('setAllUserList', response.data);
            })
            .catch(error => {
                commit(
                    "showAlert",
                    {
                        title: "Error!",
                        msg: "Error occured.",
                        type: "error",
                        position: "centerTop"
                    },
                    {root: true}
                );
            });
    },

    async getSystemUsers({commit}, data) {
        await http
            .get("users/get_system_users", null)
            .then(response => {
                commit('setSystemUserList', response.data);
            })
            .catch(error => {
                commit(
                    "showAlert",
                    {
                        title: "Error!",
                        msg: "Error occured.",
                        type: "error",
                        position: "centerTop"
                    },
                    {root: true}
                );
            });
    },

    async getFilteredUsers({commit}, data) {
        await http
            .get("users/get_filter_users", null)
            .then(response => {
                commit('setFilterUserList', response.data);
            })
            .catch(error => {
                commit(
                    "showAlert",
                    {
                        title: "Error!",
                        msg: "Error occured.",
                        type: "error",
                        position: "centerTop"
                    },
                    {root: true}
                );
            });
    },

};

export default {
    namespaced,
    state,
    getters,
    actions,
    mutations
};
